import { render, staticRenderFns } from "./facebook-graph-scrape-refresh.vue?vue&type=template&id=62636ee2&"
import script from "./facebook-graph-scrape-refresh.vue?vue&type=script&lang=js&"
export * from "./facebook-graph-scrape-refresh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports